import angular from 'angular';

import {hasMyPortal} from 'acng/core/service/env';
import angularTranslate, {provideTranslations} from 'acng/core/service/angular-translate';

import {fskTrans} from './0fsk';
import idlePopup from './idle-popup';
import './attribute/index.js';
import './config/controller/if-myportal.js';
import ngModuleName from './config/feature.js';
import './matomo.js';
import {initialLogin} from '../auth/login.js';

export default ngModuleName;

angular
  .module(ngModuleName, [angularTranslate, 'stock', idlePopup])
  .config(provideTranslations(ngModuleName))
  .run(['$injector', '$location', initialLogin])
  .filter('fskTrans', () => fskTrans)
  .factory('isPortal', () => hasMyPortal);
